var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtTwitterVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2289 60L31.7258 38.4276L9.81401 60H0.543945L27.613 33.3575L0.543945 0H24.3442L40.8408 20.3319L61.5102 0H70.7802L44.9673 25.4086L73.0292 60H49.2289ZM59.5522 53.9182H53.3112L13.8173 6.08182H20.0591L35.8767 25.2359L38.612 28.5596L59.5522 53.9182Z",
    fill: "#242E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtTwitterVector);
export default __webpack_public_path__ + "static/media/at_twitter_vector.b0eed547602dfbdd2ffdd1a260e18575.svg";
export { ForwardRef as ReactComponent };